import { useLocalObservable } from "mobx-react-lite";
import { useQueryClient } from "@tanstack/react-query";
import { useNavigate, useParams } from "react-router-dom";
import { v4 } from "uuid";
import { useState } from "react";

import { useUserToken } from "@/context/auth-context";
import { RawBlockType } from "@/components/PowerBlock/Blocks";
import { WorkflowStore } from "@/components/Workflows/WorkflowCanvas/workflow-store";
import { displayErrorToast } from "@/utils/toast";

export const useCreateDefaultWorkflow = (folderId?: number, openInNewTab = false) => {
  const { workspaceId } = useParams();
  const [isCreating, setIsCreating] = useState(false);

  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const userToken = useUserToken();
  const emptyWorkflow = useLocalObservable(
    () =>
      new WorkflowStore({
        folder_id: folderId ?? null,
        userToken: userToken,
        queryClient,
        commit_message: "Default version created",
        nodes: [
          {
            id: v4(),
            name: "New Workflow",
            node_type: RawBlockType.VARIABLE,
            configuration: {
              value: {
                type: "string",
                value: "test",
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
              } as any,
            },
            dependencies: [],
            is_output_node: true,
          },
        ],
        edges: [],
        input_variables: [],
        workflow_id: -1,
        id: -1,
        workspace_id: Number(workspaceId!),
      }),
  );

  const create = async () => {
    setIsCreating(true);
    try {
      const response = await emptyWorkflow.save("Initial commit");
      const id = response.workflow_id;
      const url = `/workspace/${workspaceId}/workflow/${id}/version/1/playground`;

      if (openInNewTab) {
        window.open(url, "_blank");
      } else {
        navigate(url);
      }
    } catch {
      displayErrorToast("Error creating workflow");
    } finally {
      setIsCreating(false);
    }
  };

  return { create, isCreating };
};
